import { graphQlClient } from '@config/graphqlClient';
import OrganizationsGraphQL from '@graphql/organization.queries';
import { Subcontractor, getSubcontractorsRequest } from '@models/organization.model';

export const subcontractorService = {
  async getSubcontractors(): Promise<Subcontractor[]> {
    const data: getSubcontractorsRequest = await graphQlClient.request(
      OrganizationsGraphQL.queries.getSubcontractors
    );

    return data.getSubcontractors || [];
  },
};

export default subcontractorService;